import LogTypes from "../../logs/exports.js";
import {
    LogChannel,
    LogRole,
} from "../../core/types.js";
import {
    createDateRangeFilter,
    createEntityFilter,
    createStaticFilter,
} from "./factories.jsx";
import {
    loadChannels,
    loadRoles,
    searchByIdOrName,
} from "./sources.js";
import { Filter } from "./types.js";

export type { Filter } from "./types.js";

type LogTypeOption = {
    id: string;
    name: string;
    label: string;
};

const LogTypeOptions: LogTypeOption[] = LogTypes.map((logType) => ({
    id      : logType.name,
    name    : logType.name,
    label   : logType.filter.name(),
}));

export const FiltersTable: Filter[] = [
    createEntityFilter({
        name    : "users",
        icon    : "group",
        label   : "Par utilisateurs",
    }),
    createEntityFilter({
        name    : "executors",
        icon    : "swords",
        label   : "Par exécuteurs",
    }),
    createEntityFilter({
        name    : "targets",
        icon    : "target",
        label   : "Par cibles",
    }),
    createStaticFilter({
        name        : "roles",
        icon        : "sell",
        label       : "Par rôles",
        options     : loadRoles as () => Promise<LogRole[]>,
        searchOption: searchByIdOrName,
    }) as Filter,
    createStaticFilter({
        name        : "channels",
        icon        : "forum",
        label       : "Par salons",
        options     : loadChannels as () => Promise<LogChannel[]>,
        searchOption: searchByIdOrName,
    }) as Filter,
    createStaticFilter<LogTypeOption>({
        name        : "types",
        icon        : "grade",
        label       : "Par types",
        options     : LogTypeOptions,
        renderOption: (option) => option.label,
        searchOption(options, query) {
            return options.filter((option) => option.label.toLowerCase().includes(query));
        },
    }) as Filter,
    createDateRangeFilter({
        name    : "time_range",
        icon    : "schedule",
        label   : "Préciser une date",
        start   : "dateStart",
        end     : "dateEnd",
    }),
];
